/** Shared gamification routes for navbar, drawer, and quick links */
export const GAMIFICATION_NAV = {
  profile: { path: '/profile', label: 'My progress', shortLabel: 'Progress' },
  leaderboard: { path: '/leaderboard', label: 'Leaderboard', shortLabel: 'Rank' },
};

export const GAMIFICATION_MENU = [
  GAMIFICATION_NAV.profile,
  GAMIFICATION_NAV.leaderboard,
];
